<template>
  <section class="c-section c-section--curse">
    <div class="container">
      <b-skeleton-wrapper :loading="contextLoading">
        <template #loading>
          <section class="py-5">
            <div class="row">
              <div class="col-12 col-lg-8">
                <div class="row gy-3">
                  <div class="col-12">
                    <b-skeleton width="80%" height="30px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton width="60%" height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton-img aspect="16:9"></b-skeleton-img>
                  </div>
                  <div class="col-12">
                    <b-skeleton width="80%" height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton width="70%" height="20px"></b-skeleton>
                  </div>
                </div>
              </div>
              <div class="col-md-4 d-none d-lg-block">
                <div class="row gy-3">
                  <div class="col-12">
                    <b-skeleton height="60px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </template>

        <div v-if="context.post" class="row">
          <div class="col-12 col-lg-8">
            <div class="c-curse-play mb-5 my-lg-5">
              <h2 class="c-curse-play__title py-3">
                {{context.post.post_title}}
              </h2>
              <div v-if="context.specialist" class="fs-16 sec-medium mb-4">
                Un curso de:
                <div class="d-inline" v-for="(item, i) of context.specialist" :key="i">
                  <span>
                    {{item.user_firstname}} {{item.user_lastname}}<span v-if="item.job">, </span>
                    {{item.job}}
                  </span>
                  <span v-if="i < context.specialist.length - 1">, </span>
                </div>
              </div>
              <div>
                <b-tabs>
                  <b-tab active>
                    <template #title>
                      <span class="fs-21">
                        <Icon icon="ph:presentation-chart"/>
                      </span>
                      Presentación
                    </template>
                    <div v-show="videoPlayer" class="c-video position-relative mb-2 mb-lg-4">
                      <div
                        id="videoPlayer"
                        class="plyr__video-embed"
                        v-html="context.video"
                        v-if="context.video">
                      </div>
                      <div v-if="!context.video" class="plyr__video-embed">
                        <img src="@/assets/img/og_image.png" alt="" class="w-100 h-100 of--cover">
                      </div>
                    </div>
                    <div
                      class="c-curse-play__button-block d-flex
                        justify-content-end align-items-center mb-2 mb-lg-5"
                    >
                      <button
                        id="popover-target-1"
                        class="c-curse-play__button my-1 my-lg-3 d-flex justify-content-center"
                      >
                        <span class="me-2">
                          <Icon icon="ri:arrow-go-back-line" class="c-curse-play__icon"/>
                        </span>
                        Compartir
                      </button>

                      <b-popover target="popover-target-1" triggers="focus" placement="top">
                        <template #title>Compartir curso</template>

                        <div class="c-social c-social--primary">
                          <a
                            :href="getSocialShare('facebook')"
                            target="_blank"
                            class="c-social__icon"
                          >
                            <Icon icon="cib:facebook-f" />
                          </a>
                          <a
                            :href="getSocialShare('twitter')"
                            target="_blank"
                            class="c-social__icon"
                          >
                            <Icon icon="akar-icons:twitter-fill" />
                          </a>
                          <a
                            :href="getSocialShare('whatsapp')"
                            target="_blank"
                            class="c-social__icon"
                          >
                            <Icon icon="akar-icons:whatsapp-fill" />
                          </a>
                          <a
                            :href="getSocialShare('linkedin')"
                            target="_blank"
                            class="c-social__icon"
                          >
                            <Icon icon="akar-icons:linkedin-fill" />
                          </a>
                        </div>
                      </b-popover>
                    </div>

                    <CourseSidebar :course="context" class="d-lg-none my-0 my-lg-5"/>

                    <div>
                      <h2 class="fs-30 w-sbold sec-medium mb-5">
                        ¿Qué incluye éste curso?
                      </h2>
                      <div
                        class="c-content w-regular fs-16 sec-medium"
                        v-html="context.post.content">
                      </div>

                      <h2 class="fs-30 w-sbold sec-medium my-5">
                        Módulos y temas
                      </h2>

                      <b-skeleton-wrapper :loading="modules.isLoading">
                        <template #loading>
                          <div class="row gy-3">
                            <div class="col-12">
                              <b-skeleton height="30px"></b-skeleton>
                            </div>
                            <div class="col-12">
                              <b-skeleton height="30px"></b-skeleton>
                            </div>
                            <div class="col-12">
                              <b-skeleton height="30px"></b-skeleton>
                            </div>
                          </div>
                        </template>

                        <template v-if="modules.data.length">
                          <div class="c-modules">
                            <div class="c-modules__title pt-2 pb-4 mb-4">
                              <div class="d-flex">
                                <span class="d-flex fs-25 gray-lightx align-items-start">
                                  <Icon icon="mdi-light:folder-multiple"/>
                                </span>
                                <h2 class="fs-21 gray-lightx w-sbold mb-0 ms-2">
                                  Módulos
                                </h2>
                              </div>
                              <span class="fs-21 gray-lightx w-sbold">
                                {{modules.duration.h}}h {{modules.duration.m}}m
                              </span>
                            </div>

                            <div class="c-modules__lections">
                              <div class="row gy-3">
                                <div
                                  v-for="(module, imodule) of modules.data"
                                  :key="`module-${imodule}`"
                                  class="col-12"
                                >
                                  <div
                                    class="c-accordion"
                                  >
                                    <button
                                      @click="module.opened = !module.opened"
                                      class="c-accordion__button"
                                    >
                                      {{imodule + 1}}. {{module.title}}
                                    </button>
                                    <b-collapse v-model="module.opened" class="c-accordion__li">
                                      <div
                                        v-for="(lection, ilection) of module.lections"
                                        :key="`lection-${imodule}-${ilection}`"
                                        class="w-100 d-flex justify-content-between
                                          my-3 px-4 px-lg-5"
                                      >
                                        <a
                                          @click.prevent="getLectionLink(lection, module)"
                                          href="#"
                                          class="c-accordion__text c-link d-flex sec-light"
                                        >
                                          <span class="ms-2 fs-14">
                                            <Icon icon="ion:ellipse"/>
                                          </span>
                                          <p class="mb-0 ms-2">
                                            {{imodule + 1}}.{{ilection + 1}}
                                            {{lection.title}}
                                          </p>
                                        </a>
                                        <span class="fs-16 sec-light">
                                          {{lection.time}}
                                        </span>
                                      </div>
                                    </b-collapse>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <p>Sin modulos</p>
                        </template>
                      </b-skeleton-wrapper>
                    </div>

                    <div>
                      <h2 class="fs-30 w-sbold sec-medium my-5">
                        Preguntas Frecuentes
                      </h2>

                      <div class="row gy-4">
                        <div
                          v-for="(question, iquestion) of context.faq"
                          :key="`question-${iquestion}`"
                          class="col-12"
                        >
                          <div
                            class="c-accordion c-accordion--primary"
                          >
                            <button
                              @click="question.opened = !question.opened"
                              class="c-accordion__button p-0"
                            >
                              <div class="d-flex align-items-center">
                                <span class="c-accordion__icon me-3">
                                  <Icon icon="akar-icons:chevron-right"/>
                                </span>
                                <p class="mb-0 pe-2">
                                  {{iquestion + 1}}.
                                  {{question.question}}
                                </p>
                              </div>
                            </button>
                            <b-collapse
                              v-model="question.opened"
                              class="c-accordion__li ms-4"
                            >
                              <div class="my-3">
                                <p
                                  class=" sec-color fs-16 w-regular mb-0 px-4"
                                  v-html="question.answer"
                                >
                                </p>
                              </div>
                            </b-collapse>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template #title>
                      <span class="fs-21">
                        <Icon icon="fluent:hat-graduation-16-regular"/>
                      </span>
                      Especialista
                    </template>
                    <!-- <div class="my-3">
                      <div class="d-flex align-items-center mb-4">
                        <figure class="c-curse-play__profile me-2">
                          <img
                            :src="context.specialist && context.specialist.avatar
                              ? context.specialist.avatar.url
                              : ''
                            "
                            :alt="context.specialist.user_firstname"
                            class="w-100 h-100 of-contain"
                          />
                        </figure>
                        <div>
                          <h2 class="fs-21 w-sbold sec-medium mb-1">
                            {{context.specialist ? context.specialist.user_firstname : ''}}
                            {{context.specialist ? context.specialist.user_lastname : ''}}
                          </h2>
                          <p class="fs-12 sec-light mb-0">
                            {{context.specialist.job}}
                          </p>
                        </div>
                      </div>
                      <div
                        class="fs-16 sec-medium"
                        v-html="context.specialist ? context.specialist.summary : ''"
                      >
                      </div>
                    </div> -->

                    <div v-if="context.specialist" class="my-2">
                      <div v-for="(item,i) of context.specialist" :key="i" class="mb-5">
                        <div class="d-flex align-items-center order-2 order-md-1 mb-3">
                          <figure v-if="item" class="c-curse-play__profile me-2">
                            <img
                              :src="item.avatar ? item.avatar.url : ''"
                              alt=""
                              class="w-100 h-100 of--cover"
                            />
                          </figure>
                          <div>
                            <h2 class="fs-21 w-sbold sec-medium mb-1">
                              {{item ? item.user_firstname : ''}}
                              {{item ? item.user_lastname : ''}}
                            </h2>
                            <p class="fs-12 sec-light mb-0">
                              {{item ? item.job : '-'}}
                            </p>
                          </div>
                        </div>
                        <div
                          class="fs-16 sec-medium"
                          v-html="item ? item.summary : ''">
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>

          </div>
          <div class="col-md-4 d-none d-lg-block">
            <CourseSidebar :course="context" class="my-5"/>
          </div>
        </div>
      </b-skeleton-wrapper>
      <div class="mt-5">
        <BannerFooter :course="context" class="c-aplication--primary-light"/>
      </div>
    </div>
  </section>
</template>

<script>
import Plyr from 'plyr';

export default {
  data() {
    return {
      context: {},
      contextLoading: true,

      videoPlayer: null,
      modules: {
        data: [],
        duration: {},

        isLoading: true,
      },

      questions: [
        {
          title: '¿En qué consisten las clases de Agroclub?',
          answer: 'AgroClub te brinda cientos de videos sobre agricultura que puedes escoger y repetir cuando quieras. Nuestros videos son realizados por excelentes profesionales para garantizar que no te pierdas de nada.',
          opened: false,
        },
        {
          title: '¿Cuánto dura cada clase?',
          answer: 'Cada clase consiste en 1 a 5 horas de video con contenido dividida en varios videos individuales que puedes visualizar y repetir cuando quieras.',
          opened: false,
        },
        {
          title: '¿Puedo parar y repetir cualquier video?',
          answer: 'Así es, a diferencia de una clase virtual en vivo en donde nunca se puede escuchar bien, la imagen es pésima y no puedes pausar, aquí en AgroClub puedes aprender mientras trabajas, conduces, cocinas, etc. Pausa y repite los videos cuando quieras.',
          opened: false,
        },
        {
          title: '¿Puedo reunirme en privado con el experto?',
          answer: 'Sí! puedes solicitar una reunión privada de forma virtual con el experto de tu interés. Para más información puedes dar clic aquí (derivar a formulario de contacto).',
          opened: false,
        },
        {
          title: '¿Me brindarán un certificado?',
          answer: 'Puedes solicitar un certificado por cada curso terminado el cual se enviará a tu email inmediatamente.',
          opened: false,
        },
      ],
    };
  },
  components: {
    BannerFooter: () => import(/* webpackChunkName: "banner-footer" */'../../components/footer/Banner.vue'),
    CourseSidebar: () => import(/* webpackChunkName: "course-sidebar" */'../../components/course/Sidebar.vue'),
  },
  created() {
    this.getFullContext({ type: 'post-type', typeName: 'course', slug: this.$route.params.course_slug });
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },
    checkoutProduct() {
      return `/checkout/course?ids=${this.course.post.id}`;
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'Course') {
        this.contextLoading = true;

        this.getFullContext({ type: 'post-type', typeName: 'course', slug: this.$route.params.course_slug });
      }
    },

    contextLoading(value) {
      if (!value) {
        document.title = `${this.context.post.title} - Agro Club`;

        this.initPlayer();
        this.getModules(this.context.post.id);
      }
    },
  },
  methods: {
    initPlayer() {
      window.setTimeout(() => {
        this.videoPlayer = new Plyr('#videoPlayer', {
          controls: [
            'play',
            'pause',
            'progress',
            'current-time',
            'duration',
            'mute',
            'volume',
            'captions',
            'settings',
            'fullscreen',
            'ended',
          ],
          previewThumbnails: false,
          captions: { active: true },
        });
      }, 200);
    },

    getModules(courseId) {
      const request = `${process.env.VUE_APP_API}/courses/${courseId}/modules`;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.modules.data = response.data.data;
            this.modules.duration = response.data.duration;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.modules.isLoading = false;
        });
    },
    getSocialShare(social) {
      let baseShare = '';

      switch (social) {
        case 'facebook':
          baseShare = 'https://www.facebook.com/sharer/sharer.php?u=';
          break;

        case 'twitter':
          baseShare = 'https://twitter.com/share?text=Un gran curso gracias a Agro Club&url=';
          break;

        case 'linkedin':
          baseShare = 'https://www.linkedin.com/sharing/share-offsite/?url=';
          break;

        case 'whatsapp':
          baseShare = 'https://api.whatsapp.com/send?text=Un gran curso gracias a Agro Club, ';
          break;

        default:
          baseShare = '';
          break;
      }

      return (baseShare)
        ? `${baseShare}${process.env.VUE_APP_SITE}${this.$route.path}`
        : '#';
    },

    getLectionLink(lection, module) {
      if (this.context.enrollment) {
        this.$router.push({ path: `/lections/${this.context.post.id}/${module.id}/${lection.slug}` }).catch(() => {});
      } else {
        this.$router.push({ path: `/checkout/course?ids=${this.context.post.id}` }).catch(() => {});
      }
    },
  },
};
</script>
